import "./FreeTransfersBadge.scss";
import { cn } from "tailwind-variants";

export default function FreeTransfersBadge({
  message = "You have 12 FREE Transfers!",
  ...restProps
}) {
  return (
    <div
      {...restProps}
      className={cn("free-transfers-badge scope-946bcc06", restProps.className)}
      data-testid="free-transfers-badge"
    >
      {message}
    </div>
  );
}
